import { Component, Input } from '@angular/core';
import { StorageService } from '../../../../services/storage.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'floating-button',
  templateUrl: './floating-button.component.html',
  styleUrls: ['./floating-button.component.scss']
})
export class FloatingButtonComponent {
  @Input() statusChat: BehaviorSubject<boolean>;
  public checkCookieCompleteStatus = StorageService.getCookie('chat-onboarding-everything-complete') === 'true';

  public openChat() {
    StorageService.setCookie('chat-onboarding-closed-preference', 'false');
    this.statusChat.next(true);
  }
}
